// Fallback mientras se descargan los chunks lazy (app/admin/auth/legales).
// La landing es eager, así que la home NUNCA muestra este loader.
// LDT-718 · En su propio fichero: lo usan App.tsx (mientras llega
// Plataforma) y Plataforma.tsx (mientras llega cada pantalla).
export default function RouteFallback() {
  return (
    <div className="flex h-screen w-full items-center justify-center">
      <div
        className="h-8 w-8 animate-spin rounded-full border-2 border-muted border-t-foreground"
        aria-label="Cargando"
      />
    </div>
  );
}
